import { GeneralStateActionTypes } from "../constants/actionTypes";

export const setIsTokenInitialized = (isInitialzed) => {
 return {
  type: GeneralStateActionTypes.SET_IS_TOKEN_INITIALIZED,
  payload: isInitialzed,
 };
};
